import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CredibilityStrip from './components/CredibilityStrip';
import Product from './components/Product';
import HowItWorks from './components/HowItWorks';
import Vision from './components/Vision';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

// The marketing page — everything that used to be App's whole body. It stays
// one scrolling page with in-page anchor links (#product, #pricing, …); only
// the legal pages live at their own URLs.
function Home() {
  return (
    <>
      <Header />
      <Hero />
      <CredibilityStrip />
      <Product />
      <HowItWorks />
      <Vision />
      <Pricing />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      {/* Any unknown path falls back to the marketing page rather than a blank
          screen — netlify.toml already rewrites every path to index.html. */}
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default App;
